module.exports = __webpack_public_path__ + "static/media/play.0978e147.svg";